module.exports = "/images/fp_logo.svg?d3b44205e7de2aed380cd4d334a400b2";